import { apiV1 } from './api';

const getDashboard = () => apiV1.get('/dashboard').then(({ data }) => data);

export const dashboardAPI = {
  getDashboard,
};
